module.exports = __webpack_public_path__ + "static/media/42-9.bc501071.mp3";